import React, { useEffect, useState } from 'react';
// import { sendMail } from '../../sendMail';
// import Modal from '../../components/modal/modal';
import people from '../../assets/people.webp';
import ai from '../../assets/ai2.webp';
import './header.css';
// import '../../components/querycard/querycard.css';
import Modal from '../../components/modal/modal';

const Header = () => {
  useEffect(() => {
    const imageList = [ai, people];
    imageList.forEach((image) => {
      const img = new Image();
      img.src = image;
      img.setAttribute('loading', 'eager'); // Set loading attribute to "eager" for preloading
    });
  }, []);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains('modal')) {
      closeModal();
    }
  };
  return (
    <div>
      <div className="gpt3__header section__padding" id="home">
        <div className="gpt3__header-content">
          <h1 className="gradient__text">Let&apos;s Build Something amazing with AlgoDoor</h1>
          <div className="gpt3__header-content__input">
            <button key="modalBtn" type="button" className="header-quote-btn" onClick={openModal}>Get A Quote</button>
          </div>
          {isModalOpen && (
            <div className="modal-overlay" onClick={handleOutsideClick}>
              <Modal closeModal={closeModal} />
            </div>
          )}
          <div className="gpt3__header-content__people">
            <img src={people} alt="Algodoor students and professionals" />
            <p>1600+ people requested a service in last 15 months</p>
          </div>
        </div>

        <div className="gpt3__header-image">
          <img src={ai} alt="Digital AI illustration for software training" />
        </div>
      </div>
    </div>
  );
};

export default Header;
